import React from 'react';
import Lightbox from "react-image-lightbox";
import Div from "../util/Div";
import 'react-image-lightbox/style.css';
import "./GalleryBam.scss";
import lang from "../../i18/lang";
import {HOME_PAGE} from "../../const/api";
import move_to_previous from "../../assets/icons/move-to-previous.png";
import move_to_next from "../../assets/icons/move-to-next.png";
import {isMobile} from 'react-device-detect';
import IMAGES from "./Images";

const GALLERY_SIZE = 8;

class GalleryBam extends React.Component {

    constructor(props) {
        super(props);
    }

    state = {
        photoIndex: 0,
        isOpen: false,
        displayedImages: [],
        slideNumber: 1,
        numberOfSlides: Math.ceil(IMAGES.length / GALLERY_SIZE)
    };

    componentDidMount() {
        this.setState({
            displayedImages: this.getImages(1)
        });
    }

    nextSlide = () => {
        if (this.state.slideNumber + 1 > this.state.numberOfSlides) {
            return;
        }

        this.setState({
            slideNumber: this.state.slideNumber + 1,
            displayedImages: this.getImages(this.state.slideNumber + 1)
        })
    };

    prevSlide = () => {
        if (this.state.slideNumber - 1 <= 0) {
            return;
        }

        this.setState({
            slideNumber: this.state.slideNumber - 1,
            displayedImages: this.getImages(this.state.slideNumber - 1)
        });
    };

    getImages(slideNumber) {
        const firstIndex = slideNumber * GALLERY_SIZE - GALLERY_SIZE;
        const lastIndex = firstIndex + GALLERY_SIZE;

        return IMAGES.slice(firstIndex, lastIndex);
    }

    openImage = (position) => {
        this.setState({
            isOpen: true,
            photoIndex: ((this.state.slideNumber - 1) * GALLERY_SIZE) + position
        })
    };

    scrollToRef = (ref) => window.scrollTo({behavior: 'smooth', top: ref.current.offsetTop});

    render() {

        return (
            <div id="galerija" className="gallery-bam-wrapper" ref={this.props.ref_gallery}>
                <div className="title">{lang.srb.section.gallery.title}</div>
                <h5>{lang.srb.section.gallery.sub_title}</h5>
                <Div hidden={!this.state.isOpen}>
                    <Lightbox
                        mainSrc={`${HOME_PAGE}${IMAGES[this.state.photoIndex].src}`}
                        nextSrc={`${HOME_PAGE}${IMAGES[(this.state.photoIndex + 1) % IMAGES.length].src}`}
                        prevSrc={`${HOME_PAGE}${IMAGES[(this.state.photoIndex + IMAGES.length - 1) % IMAGES.length].src}`}
                        onMoveNextRequest={() => this.setState({
                            photoIndex: (this.state.photoIndex + 1) % IMAGES.length
                        })}
                        onMovePrevRequest={() => this.setState({
                            photoIndex: (this.state.photoIndex + IMAGES.length - 1) % IMAGES.length
                        })}
                        onCloseRequest={() => this.setState({isOpen: false})}
                    />
                </Div>
                <div className="gallery">
                    {
                        this.state.displayedImages.map((image, index) => {
                            const src = `${HOME_PAGE}${isMobile ? image.src : image.thumbnail}`;

                            return (
                                <div className="image" onClick={() => this.openImage(index)}>
                                    <img src={src}/>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="navigation-bottom">
                    <div onClick={() => {
                        this.prevSlide();
                        this.scrollToRef(this.props.ref_gallery);
                    }} className="arrow">
                        <img src={move_to_previous} alt="Previous"/>
                    </div>
                    <div onClick={() => {
                        this.nextSlide();
                        this.scrollToRef(this.props.ref_gallery);
                    }} className="arrow">
                        <img src={move_to_next} alt="Next"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default GalleryBam;

